import { SelectOption } from '@/components/Form/src/types'
import { annualCheckingEnum } from './AnnualCheckingEnum'

const StatusTrainingOptions: SelectOption[] = [
  {
    label: 'H1',
    value: annualCheckingEnum.StatusofTraining.H1
  },
  {
    label: 'H2',
    value: annualCheckingEnum.StatusofTraining.H2
  },
  {
    label: 'C1',
    value: annualCheckingEnum.StatusofTraining.C1
  },
  {
    label: 'C2',
    value: annualCheckingEnum.StatusofTraining.C2
  },
  {
    label: 'Part Time',
    value: annualCheckingEnum.StatusofTraining.PartTime
  }
]

const annualCheckingStatusOption: SelectOption[] = [
  {
    label: 'Submitted',
    value: annualCheckingEnum.Status.SubmittedByTrainee
  },
  {
    label: 'Rejected by COS / Supervisor',
    value: annualCheckingEnum.Status.Rejected
  },
  {
    label: 'Endorsed by COS / Supervisor',
    value: annualCheckingEnum.Status.Endorsed
  }
]

const endorsementUserOptions: SelectOption[] = [
  {
    label: 'COS/Training Coordinator',
    value: annualCheckingEnum.EndorsementUser.COS
  },
  {
    label: 'Supervisor',
    value: annualCheckingEnum.EndorsementUser.Supervisor
  }
]

export const annualCheckingOptions = {
  StatusTrainingOptions,
  annualCheckingStatusOption,
  endorsementUserOptions
}
